import { defineMessage } from 'services/localization';

export const messages = {
    myDecisionRequiredLinkName: defineMessage('requires_my_approval_all'),
    myDecisionRequiredLinkTitle: defineMessage('requests_that_require_my_decision'),
    myReviewRequiredLinkName: defineMessage('requires_my_review_all'),
    myReviewRequiredLinkTitle: defineMessage('requests_that_require_my_review'),
    myOcrRequestsLinkName: defineMessage('captured_by_me'),
    myOcrRequestsLinkTitle: defineMessage('captured_by_me'),
    myOpenLinkName: defineMessage('created_by_me'),
    myOpenLinkTitle: defineMessage('approval_requests_i_submitted'),
    myDraftLinkName: defineMessage('drafts'),
    myDraftLinkTitle: defineMessage('draft_requests'),
    myReadyToPayName: defineMessage('ready_to_pay'),
    myReadyToPayTitle: defineMessage('ready_to_pay'),
};
